import { inject, injectable } from "inversify";
import { IDefaultResponse } from "../../types";
import { ISlackPayload, ISlackMessage } from "../ports/SlackMessage";
import { type HttpClient } from "@/core/services/protocols/types";
import { DITypes } from "@/core/@types/types";
import "reflect-metadata";

export interface ISuccessModelSlack {
  ContaBancariaId: string;
  itemData: string;
}

@injectable()
export default class SlackMessageAdapter implements ISlackMessage {
  @inject(DITypes.FINANCAS_API_HTTP_CLIENT)
  private httpClientFinancasApi!: HttpClient;

  async enviarMensagem(payload: ISlackPayload): Promise<void> {
    await this.httpClientFinancasApi?.post<IDefaultResponse>({
      url: "/v1/SlackUtilAPI/SendSlackMessage",
      body: {
        ...payload
      }
    });
  }
}
